<template>
  <div class="red-gold-container">
    <div class="header">
      <h1 class="title">{{basics.headCn}}</h1>
      <div class="time">{{ currentTime }}</div>
      <div class="subtitle">{{basics.headRollDesc}}</div>
    </div>

    <div class="price-card">
      <div class="price-icon">
        <img src="@/assets/qd.png" alt="logos" class="logos" />
        <div class="icon-label">实时金价</div>
      </div>
      <div class="price-list">
        <div class="price-item" v-for="(item, index) in priceList" :key="index">
          <div class="price-name">{{ item.productName }}</div>
          <div class="price-value">
            <span class="price-symbol">¥</span>
            <span class="price-number">{{ item.salePrice || '——' }}</span>
            <span class="price-unit">/克</span>
          </div>
        </div>
      </div>
    </div>

    <div class="qrcode-section">
      <img v-if="basics.barcodeUrl" :src="basics.barcodeUrl" class="qrcode-img" alt="小程序码" />
      <div class="qrcode-text">{{ basics.company }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted ,getCurrentInstance} from 'vue';
import api from '@/api/http';
const { proxy } = getCurrentInstance();

const currentTime = ref('');
const priceList = ref([]);
const summaryText = ref('识别小程序码进入商城挑选');
const tenantId = ref('');
const basics = ref('');


let timerId = null;
let refreshTimer = null;

const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const updateTime = () => {
  currentTime.value = formatDate(new Date());
};

const fetchPriceData = () => {
 const socket = new WebSocket(proxy.$globalConfig.wsURL);

  socket.addEventListener('open', () => {
    console.log('WebSocket连接成功');
    const requestData = { msgType: 'url', data: tenantId.value };
    socket.send(JSON.stringify(requestData));
  });

  socket.addEventListener('message', (event) => {
    const response = JSON.parse(event.data);
    if (response.length >= 1 && response[0].productName) {
      priceList.value = response.filter(item => item.productName);
    }
  });

  socket.addEventListener('error', (error) => {
    console.error('WebSocket连接错误:', error);
  });

  socket.addEventListener('close', () => {
    console.log('WebSocket连接关闭,开始重连');
    setTimeout(() => {
      fetchPriceData();
    }, 3000);
  });
};

const fetchBasicInfo = () => {
  api.get('/metalMarket/sysTenantBoardConf/getByWebUrl/' + tenantId.value).then(response => {
    if (response.data) {
        basics.value = response.data|| {};
      summaryText.value = response.data.company || '识别小程序码进入商城挑选';
    }
  });
};

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search);
  tenantId.value = urlParams.get('v') || '';

  updateTime();
  timerId = setInterval(updateTime, 1000);

  if (tenantId.value) {
    fetchBasicInfo();
    fetchPriceData();
  }

  refreshTimer = setInterval(() => {
    fetchBasicInfo();
  }, 120000);
});

onUnmounted(() => {
  clearInterval(timerId);
  clearInterval(refreshTimer);
});
</script>

<style scoped>
.red-gold-container {
  width: 100%;
  height: 100%;
  background: #d42027;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px ;
  box-sizing: border-box;
  overflow-y: auto;
}

.header {
  text-align: center;
  color: #fff;
  margin-bottom: 30px;
}

.title {
  font-size: 42px;
  font-weight: bold;
  margin: 0 0 20px 0;
  letter-spacing: 5px;
}

.time {
  font-size: 18px;
  margin-bottom: 10px;
  opacity: 0.9;
}

.subtitle {
  font-size: 24px;
  opacity: 0.85;
}

.price-card {
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  width: 90%;
  display: flex;
  align-items: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.15);
  margin-bottom: 40px;
}

.price-icon {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 10px;
  flex-shrink: 0;
}
.price-icon img{width:60px}
.icon-circle {
  width: 60px;
  height: 60px;
  border: 3px solid #d42027;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
}

.icon-text {
  font-size: 24px;
  color: #d42027;
  font-weight: bold;
}

.icon-label {
  font-size: 18px;
  color: #d42027;
  text-align: center;
}

.price-list {
  flex: 1;
  min-width: 0;
}

.price-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 2px solid #e8e8e8;
}

.price-item:last-child {
  border-bottom: none;
}

.price-name {
  font-size: 60px;
  color: #333;
}

.price-value {
  display: flex;
  align-items: baseline;
}

.price-symbol {
  font-size: 13px;
  color: #d42027;
  margin-right: 3px;
}

.price-number {
  font-size: 72px;
  color: #d42027;
  font-weight: bold;
}

.price-unit {
  font-size: 40px;
  color: #333;
  margin-left: 5px;
}

.qrcode-section {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.qrcode-img {
  width: 150px;
  height: 150px;
  border-radius: 6px;
  background: #fff;
  padding: 6px;
  box-sizing: border-box;
}

.qrcode-text {
  color: #fff;
  font-size: 24px;
  margin-top: 12px;
  text-align: center;
  white-space: pre-wrap;
  opacity: 0.9;
}

@media screen and (max-width: 768px) {
  .red-gold-container {
    padding:20px 0;
  }

  .title {
    font-size: 32px;
  }

  .time {
    font-size: 15px;
  }

  .subtitle {
    font-size: 13px;
  }

  .price-card {
    padding:5px 15px;
    padding-left: 5px;
    
  }

  .price-icon {
    margin-bottom: 12px;
  }

  .icon-circle {
    width: 36px;
    height: 36px;
    margin-right: 10px;
    margin-bottom: 0;
  }

  .icon-text {
    font-size: 18px;
  }

  .icon-label {
    font-size: 13px;
  }

  .price-name {
    font-size: 18px;
  }
  .price-unit {
    font-size: 14px;
  }
  .price-number {
    font-size: 26px;
  }
.price-icon img{width:36px}

  .qrcode-img {
    width: 150px;
    height: 150px;
  }

  .qrcode-text {
    font-size: 15px;
  }
}
</style>